import { AbstractPopUp, AbstractPopUpParams } from './AbstractPopUp';
import { Reward, RewardItem } from '../core/reward/Reward';
import { TextStyles } from '../utils/TextStyles';
import { createButton, createSprite, resizeTextByReference, translate } from '../utils/GameEngine';
import TextStyle = PIXI.TextStyle;
import Sprite = PIXI.Sprite;
import Text = PIXI.Text;
import Container = PIXI.Container;
import { RewardPanel } from '../UI/elements/rewardChest/RewardPanel';
import { Button } from '../UI/elements/buttons/Button';

export interface DailyRewardPopupParams extends AbstractPopUpParams {
    reward: Reward;
    callback: () => any;
}

export class DailyRewardPopup extends AbstractPopUp {
    private rewardContainer: PIXI.Container;

    protected drawLayout(params?: any): void {
        super.drawLayout(params);
        this.addTitle();
        this.addRewards();
        const claimButton: Button = createButton(
            'green_btn_large@2x',
            this,
            (): void => {
                this.hide();
                params.callback();
            },
            translate('Claim', true) + '!',
            true,
            true,
            1
        );
        claimButton.position.set(390, 460);
    }

    protected addFirstText(topOffset: number): void {
        const style: TextStyle = TextStyles.uiText.clone();
        style.fontSize = '24px';
        style.wordWrap = true;
        style.wordWrapWidth = this.textBox.width - 16;
        this.text = new PIXI.Text(this.params.text, style);
        resizeTextByReference(this.text, this.textBox, 0);
        this.text.anchor.set(0.5, 0.5);
        style.wordWrapWidth = this.textBox.width - 16;
        this.text.position.set(
            this.textBox.x + this.textBox.width / 2,
            this.textBox.y + topOffset * 3.5
        );
        this.background.addChild(this.text);
    }

    private addTitle(): void {
        const style: TextStyle = TextStyles.smallTextWhite.clone();
        style.lineHeight = 20;
        const levelText: Text = new Text(translate('Daily\nReward', true), style);
        levelText.anchor.set(0.5, 0);
        levelText.position.set(this.imageBox.x + this.imageBox.width / 2, 35);
        this.background.addChild(levelText);
    }

    private addRewards(): void {
        this.rewardContainer = new Container();
        (this.params as DailyRewardPopupParams).reward.rewards.forEach((reward: RewardItem, index: number): void => {
            const rewardPanel: RewardPanel = new RewardPanel(reward);
            this.rewardContainer.addChild(rewardPanel);
            // rewardPanel.visible = false;
            // rewardPanel.scale.set(0, 0);
            rewardPanel.x = rewardPanel.width / 2 + index * 120;
        });
        this.addChild(this.rewardContainer);
        this.rewardContainer.pivot.set(this.rewardContainer.width / 2, this.rewardContainer.height / 2);
        this.rewardContainer.position.set(
            this.textBox.x + this.textBox.width / 2,
            this.background.height - 80
        );
    }
}